import { id, root } from './customers';
import * as idEndpoints from './id';
import { masterEcg } from './master-ecg';
import { names } from './names';

export const customers = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
  masterEcg,
  names,
};
